var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 9.49935V1.69233C1 1.44422 1 1.32017 1.07708 1.24309C1.15415 1.16602 1.27821 1.16602 1.52632 1.16602H9.72936C10.2701 1.16602 10.5405 1.16602 10.6078 1.32847C10.6751 1.49092 10.4839 1.68211 10.1015 2.06449L7.13106 5.03495C6.99071 5.1753 6.92054 5.24548 6.92054 5.33268C6.92054 5.41989 6.99071 5.49006 7.13106 5.63041L10.1015 8.60087C10.4839 8.98325 10.6751 9.17445 10.6078 9.3369C10.5405 9.49935 10.2701 9.49935 9.72936 9.49935H1ZM1 9.49935V12.8327",
    stroke: "white",
    strokeWidth: 1.05263,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagLight);
export default __webpack_public_path__ + "static/media/flagLight.d28e9f746552a2d41bf1e43028dd5748.svg";
export { ForwardRef as ReactComponent };